/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summerinocccoolingtemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Summer unoccupied cooling setpoint" |
*
* @param {Ahu_History_Key_Summerinocccoolingtemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summerinocccoolingtemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Summerinocccoolingtemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summerinocccoolingtemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer unoccupied cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid inoccupation été")
});
export { ahu_history_key_summerinocccoolingtemperaturesetpoint4 as "ahu_history_key_summerInoccCoolingTemperatureSetpoint" }